// Javascript DOM (Window) helpers to handle some things that React can't do (or
// we don't know how to do! :-)
export const openInNewTab = (url: string): void => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
  if (newWindow !== null) {
    newWindow.opener = null
  }
}
